import { getBoneBoundary, offsetPolygon } from "@project-rouge/rg-three";
function getWingPoly({ building, bone, level, skipCornerCores = false }) {
	return offsetPolygon(getBoneBoundary({
		building,
		bone,
		level,
		includeCornerCores: skipCornerCores ? "never" : "always"
	}), .01).map((b) => [b[0], b[2]]);
}
export { getWingPoly };

//# sourceMappingURL=index213.js.map